const customEvent = (name, eventData, bubbles = true, cancelable = false) =>
  new CustomEvent(name, {
    detail: eventData,
    bubbles,
    cancelable,
  });
export default customEvent;
